import React from 'react'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import { Address } from 'common/components/address'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const ModalAddress = ({ addressTuple }) => (
  <Address
    source={{ formatted_address: addressTuple }}
    separator=' | '
    as='div'
    className={cx('address', 'u-ellipsis')}
    elmId='modal_address'
  />
)

ModalAddress.propTypes = {
  addressTuple: PropTypes.array,
}

export default ModalAddress
